'use client';
import { getAddressStore } from '@/components/address/AddressStore';
import { curPostCodeOrAddress } from '@/utils/addressRequestUtils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import CDNImage from '@/components/cdnImage/cdnImage';

import ArrowIcon from '@/images/icon/arrow-default.svg';

import { dataExpTagConfig } from '@/components/product/const';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25217';

import LocationSvg from '@/assets/icons/dp-location.svg';
import AddressSelectDrawer from '@/components/address/AddressSelect/AddressSelectDrawer';
import { useTranslation } from '@/i18n/client';
import { AddressSelectorWrapper } from '@/styles/product';
import { type fulfillmentMethodListProps } from '@/apis/dp/floor.interface';

function AddressSelector({ floors, skuId }: any) {
  const { t } = useTranslation();
  const addressStore = getAddressStore();
  const postCode = addressStore.detailPostCode.get();
  const [isClient, setIsClient] = useState(false);
  const productShipPromiseFloor = floors.productShipPromiseFloor?.data;
  const deliveryInfo = productShipPromiseFloor?.deliveryInfo;
  const fulfillmentMethodList = deliveryInfo?.fulfillmentMethodList || [];

  const { promise, freightThresholdTextIntergation } =
    productShipPromiseFloor?.['C-M#viewAddressItem&addressCore'] || {};
  useEffect(() => {
    setIsClient(true);
  }, []);

  const [isOpenDialog, setIsOpenDialog] = useState(false);

  useEffect(() => {
    initPostCode();
  }, []);

  const initPostCode = async () => {
    const postCode = await curPostCodeOrAddress();
    const detailPostCode = await curPostCodeOrAddress(true);
    addressStore.setPostCode(postCode);
    addressStore.setDetailPostCode(detailPostCode);
  };

  const handlerDeliver = () => {
    sendClickTrack.Productdetail_SZFloor_Click({
      mainskuid: skuId,
    });
    setIsOpenDialog(true);
  };

  const postCodeSplitted = postCode.replaceAll(t('dp.deliverTo'), '');

  return (
    <AddressSelectorWrapper className='address-selector'>
      {
        <div
          className='deliver-frame'
          exptag={'exp|' + EXPOSURE_RECORD.Productdetail_SZFloor_Expo}
          data-exptag-config={dataExpTagConfig}
          data-exptag-json-param={JSON.stringify({ mainskuid: skuId })}
          id='dp_address_wrap'
        >
          <div className='update-postcode' onClick={handlerDeliver}>
            <span className='col'>
              <LocationSvg />
              <strong>{postCodeSplitted}</strong>
            </span>

            <p className='arrow-right'>
              <ArrowIcon />
            </p>
          </div>
          {!deliveryInfo ? (
            (promise || freightThresholdTextIntergation) && (
              <div className='intro'>
                {promise && (
                  <div className='promise' dangerouslySetInnerHTML={{ __html: promise }} />
                )}
                {isClient && freightThresholdTextIntergation && (
                  <div dangerouslySetInnerHTML={{ __html: freightThresholdTextIntergation }} />
                )}
              </div>
            )
          ) : (
            <div className={'performance_info'}>
              {fulfillmentMethodList.length > 0 &&
                fulfillmentMethodList.map((item: fulfillmentMethodListProps, index: number) => (
                  <>
                    <div className={'info'}>
                      <div className={'info_title'}>
                        <CDNImage src={item.icon} width={34} height={34} />
                        <div
                          className={'info_title_content'}
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                      </div>
                      {
                        <span
                          className={'info_desc'}
                          dangerouslySetInnerHTML={{ __html: item.deliveryTime! }}
                        />
                      }
                      {<span dangerouslySetInnerHTML={{ __html: item.priceIntergation! }} />}
                    </div>
                    {index + 1 !== fulfillmentMethodList.length && (
                      <div className={'or_divider'}>{t('dp.or')}</div>
                    )}
                  </>
                ))}
            </div>
          )}
        </div>
      }
      <AddressSelectDrawer openDrawer={isOpenDialog} setOpenDrawer={setIsOpenDialog} />
    </AddressSelectorWrapper>
  );
}
export default observer(AddressSelector); // 导出被 observer 包裹后的组件
